import PropTypes from 'prop-types';
import get from 'lodash/get';

import FavoriteOption from '../../shared/FavoriteOption';
import FavoriteStyleContext from '../../player/controls/favorite/context/FavoriteStyleContext';

import css from './favorite-menu-option.module.scss';
import sharedCss from './shared-menu-option.module.scss';

// exported for testing
const FavoriteMenuOption = ({ action, guideItem }) => {
  const guideId = get(guideItem, 'guideId');

  return (
    <FavoriteStyleContext.Provider
      value={{
        iconClassName: sharedCss.iconClassName,
        unFavoritedClassName: css.unFavoritedIcon,
      }}
    >
      <FavoriteOption
        guideId={guideId}
        actionOrFollowOption={action}
        className={sharedCss.menuOption}
        isContainerItemFavorite
      />
    </FavoriteStyleContext.Provider>
  );
};

FavoriteMenuOption.propTypes = {
  guideItem: PropTypes.object.isRequired,
  action: PropTypes.object.isRequired,
};

export default FavoriteMenuOption;
